<template>
  <div>
    <v-form ref="form" lazy-validation v-model="valid" class="d-grid gap-8">
      <BaseCard
        :title="localStorage.translations.pages.sales_project['sections']['planiruemye-resursy']"
        class-body="d-grid gap-8 grid-col-md-1-1-2"
      >
        <BaseInput
          :label="localStorage.translations.pages.sales_project['planned_resources-labels']['rukovoditel-proekta']"
          :label-second="localStorage.translations.pages.sales_project['planned_resources-labels']['vyberite-v-spiske']"
          v-model="plannedResourcesData.project_manager_employee_id"
          type="autocomplete"
          :items="employeeAll"
          item-value="id"
          :item-text="(item) => item.user.first_name + ' ' + item.user.last_name"
          :view-value="
            plannedResourcesData.project_manager_employee_id ?
            findItemData(employeeAll, plannedResourcesData.project_manager_employee_id) :
            '—'"
          :placeholder="localStorage.translations.pages.sales_project['planned_resources-time_period-inputs']['ne-vybrano']"
          :view="$userCheckAccess({ abilities: 'view_all_client_project'}) ? !edit : true"
          prepend-inner-icon="search"
        />
        <BaseInput
          :label="localStorage.translations.pages.sales_project['planned_resources-labels']['rukovoditel-prodazh']"
          :label-second="localStorage.translations.pages.sales_project['planned_resources-labels']['vyberite-v-spiske']"
          v-model="plannedResourcesData.sales_manager_employee_id"
          type="autocomplete"
          :items="employeeAll"
          item-value="id"
          :item-text="(item) => item.user.first_name + ' ' + item.user.last_name"
          :view-value="
          plannedResourcesData.sales_manager_employee_id ?
          findItemData(employeeAll, plannedResourcesData.sales_manager_employee_id) :
          '—' "
          :placeholder="localStorage.translations.pages.sales_project['planned_resources-time_period-inputs']['ne-vybrano']"
          :view="!edit"
          prepend-inner-icon="search"
        />
        <BaseInput
          :label="localStorage.translations.pages.sales_project['planned_resources-labels']['primechanie']"
          v-model="plannedResourcesData.resources_notes"
          type="textarea"
          :view="!edit"
        />
      </BaseCard>
      <ProjectPlannedResourcesResponsibleAndSubscribers
        v-if="$route.name !== 'SalesProjectCreate'
          && (userType === 'subscriber' || $userCheckAccess({ abilities: 'view_all_client_project' }))
          && (companiesConfig.responsible_person !== '0' || companiesConfig.subscribers !== '0')"
        :edit="edit"
      />
      <ProjectPlannedResourcesWorkType
        v-for="(item) in workClientProjectsWorkTypeAll_project"
        :key="'id_' + item.id"
        :item="item"
        :edit="edit"
      />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProjectPlannedResourcesResponsibleAndSubscribers from './responsibleAndSubscribers/ProjectPlannedResourcesResponsibleAndSubscribers'
import ProjectPlannedResourcesWorkType from './ProjectPlannedResourcesWorkType'

export default {
  name: 'ProjectPlannedResources',
  props: {
    edit: Boolean,
    createContinue: Boolean,
    tableSticky: Boolean,
    projectRequiredData: Object,
  },
  components: {
    ProjectPlannedResourcesResponsibleAndSubscribers,
    ProjectPlannedResourcesWorkType,
  },
  data() {
    return {
      valid: false,
      plannedResourcesData: {
        resources_notes: '',
        project_manager_employee_id: null,
        sales_manager_employee_id: null,
      },
      workClientAll: [],
      loadingData: false,
    }
  },
  created() {
    this.onDownloadData()
  },
  watch: {
    workClientProjectShow() {
      this.onActualData()
    },
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    plannedResourcesData: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
    workClientProjectsResponsibleEmployeesAll_project: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
      },
      deep: true,
    }
  },
  mounted() {
    this.onActualData()
  },
  computed: {
    ...mapGetters(['inputRules', 'companiesConfig']),
    ...mapGetters('user', ['userType', 'userData']),
    ...mapGetters('workClientProjectsWorkType', [
      'workClientProjectsWorkTypeDefault',
      'workClientProjectsWorkTypeAll_project',
    ]),
    ...mapGetters('workClientProjectsResponsibleEmployees', [
      'workClientProjectsResponsibleEmployeesAll_project',
    ]),
    ...mapGetters('workClientProjectsWorkTypePeriod', [
      'workClientProjectsWorkTypePeriodAll_project',
    ]),
    ...mapGetters('employee', ['employeeAll']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    checkUserProjectManager() {
      return this.userData && !!this.userData.employee
        ? this.userData.employee.id === this.workClientProjectShow.project_manager_employee_id
        : false
    },
    pageSalesProjectShow() {
      return this.$route.name === 'SalesProjectShow' || this.$route.name === 'SalesProjectShowEdit'
    },
    pageSalesProjectCreate() {
      return this.$route.name === 'pageSalesProjectCreate'
    },
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectUpdate']),
    ...mapActions('workClientProjectsWorkType', [
      'onWorkClientProjectsWorkTypeUpdate',
    ]),
    ...mapActions('employee', ['onEmployeeAll']),
    ...mapActions('workClientProjectsWorkTypePeriod', [
      'onWorkClientProjectsWorkTypePeriodAll_project',
    ]),
    ...mapActions('commonUser', ['onCommonUserData']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions('workClientProjectsResponsibleEmployees', [
      'onWorkClientProjectsResponsibleEmployeesUpdate',
    ]),
    onDownloadData() {
      this.loadingData = true
      let queries = [this.onEmployeeAll()]
      if (this.$route.name !== 'SalesProjectCreate') {
        queries.push(this.onWorkClientProjectsWorkTypePeriodAll_project(this.$route.params.id))
      }
      Promise.all(queries).then(() => (this.loadingData = false))
    },
    findItemData(array, itemId) {
      if (array.length && itemId) {
        let data = array.find((i) => i.id === itemId)
        if (data) {
          if (array == this.employeeAll && itemId) {
            return data.user.first_name + ' ' + data.user.last_name
          } else {
            return data.name
          }
        } else {
          return '—'
        }
      } else {
        return '—'
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: {
          plannedResourcesData: this.plannedResourcesData,
          responsiblePersonData: this.workClientProjectsResponsibleEmployeesAll_project[0] },
        overwrite,
      })
    },
    onActualData() {
      if (this.workClientProjectShow) {
        this.plannedResourcesData.resources_notes = this.workClientProjectShow.resources_notes
        this.plannedResourcesData.project_manager_employee_id = this.workClientProjectShow.project_manager_employee_id
        this.plannedResourcesData.sales_manager_employee_id = this.workClientProjectShow.sales_manager_employee_id
        if (this.edit) {
          this.onCheckChange({ overwrite: true })
        }
      }
    },
    onCreateOrUpdate() {
      return new Promise((resolve, reject) => {
        if (this.validate()) {
          let promises = []
          if (this.$checkNavigationGuardianChange('plannedResourcesData')) {
            this.lodingData = true
            let data = this.plannedResourcesData
            if (this.createContinue) {
              data.id = this.$route.params.id
              data.name =
                (this.projectRequiredData && this.projectRequiredData.name) ||
                this.workClientProjectShow.name
              data.work_client_id =
                (this.projectRequiredData && this.projectRequiredData.work_client_id) ||
                this.workClientProjectShow.work_client.id
              data.business_segment_id = this.workClientProjectShow.business_segment_id
              data.end_date = this.workClientProjectShow.end_date
              data.project_type_id = this.workClientProjectShow.project_type_id
              data.start_date = this.workClientProjectShow.start_date
              promises.push(this.onWorkClientProjectUpdate(data))
            } else {
              this.lodingData = false
              resolve(data)
            }
          }
          if (this.$checkNavigationGuardianChange('responsiblePersonData')) {
            let data1 = {}
            data1.project_id = Number(this?.workClientProjectsResponsibleEmployeesAll_project[0]?.project_id || 0)
            data1.employee_id = Number(this?.workClientProjectsResponsibleEmployeesAll_project[0]?.employee?.id || 0)
            data1.hour_salary = Number(this?.workClientProjectsResponsibleEmployeesAll_project[0]?.hour_salary || 0)
            data1.unit_salary = Number(this?.workClientProjectsResponsibleEmployeesAll_project[0]?.unit_salary || 0)
            promises.push(this.onWorkClientProjectsResponsibleEmployeesUpdate(data1))
          }
          Promise.all(promises)
            .then(() => {
              this.onCheckChange({ overwrite: true })
              this.lodingData = false
              resolve(true)
            })
            .catch((err) => {
              console.log('err', err)
              if (!this.pageSalesProjectShow) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common['notifications']['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
                this.lodingData = false
              } else resolve(false)
            })
        } else {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'fill_in_required_fields'
                ],
              IsError: true,
            },

            { root: true },
          )
          reject(false)
        }
      })
    },
  },
}
</script>